// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"0c0dfaae","239":"fabea609","389":"de31ff3a","732":"85739eda","857":"340a0df5","977":"4d282140"}[chunkId] + ".chunk.js";
};